import { type InvalidateOn, useMutationWithInvalidation } from '@/shared/composables/useMutationWithInvalidation'
import { type MaybeRefOrGetter, toValue } from 'vue'
import { z } from 'zod'
import { allocateCreditNoteSchema } from '@/features/invoices/models/schemas/credit-notes'
import { allocateCreditNotesToInvoice } from '@/features/invoices/api/allocate-credit-notes-to-invoice'
import { creditNoteQueryKeys, invoiceQueryKeys } from '@/features/invoices/query-keys'

export const useReplaceCreditNoteAllocations = (invoiceId: MaybeRefOrGetter<number>, invalidateOn?: InvalidateOn) => useMutationWithInvalidation({
  mutationKey: creditNoteQueryKeys.allocatable(invoiceId),
  mutationFn: (allocations: z.infer<typeof allocateCreditNoteSchema>[]) => allocateCreditNotesToInvoice(
    toValue(invoiceId),
    allocations
  )
}, [
  creditNoteQueryKeys.allocatable(invoiceId),
  invoiceQueryKeys.paginated(),
], invalidateOn);
